import { Moon, Sun } from "@/assets/icons";
import { ThemeEnum } from "@/enums";
import { useTheme } from "@/hooks";
import { Button } from "@/ui/button";

export const ThemeSwitcher = () => {
    const { setTheme } = useTheme();

    return (
        <Button variant="icon">
            <Sun
                className="absolute rotate-90 scale-0 text-gray-500 transition-all dark:rotate-0 dark:scale-100"
                size={16}
                onClick={() => setTheme(ThemeEnum.LIGHT)}
            />
            <Moon
                className="rotate-0 scale-100 text-gray-500 transition-all dark:-rotate-90 dark:scale-0"
                size={16}
                onClick={() => setTheme(ThemeEnum.DARK)}
            />
        </Button>
    );
};
